import { hidePreloader, showPreloader } from "../preloader";
import ajax from "../ajax";
import { showModalFromHtml } from "../modal";
import { updateCartFromHTML } from "../cart";
import EventBus from "../../events/EventBus";
import CartEventBus from "../../screens/cart/CartEventBus";
import { addGlobalLiveEventListener } from "../../utils";
/**
 * Единая функция добавления товаров и сетов в корзину
 */
export async function handleAddToCartButtonClick({ id, type = 'offer', cnt = 1, silent = false }) {
    showPreloader();
    try {
        const payload = { cnt };
        if (id) {
            payload.id = id;
        }
        if (type !== 'offer') {
            payload.type = type;
        }
        const response = await ajax('/api/cart/add', payload, { dataType: 'json' });
        const result = await response.json();
        if (result.ok) {
            if (result.basket_block) {
                updateCartFromHTML(result.basket_block);
            }
            if (!silent && result.html) {
                showModalFromHtml(result.html);
            }
            CartEventBus.emit('cart:refresh');
            // Если в ответе пришло обновленное состояние сета
            if (result.data) {
                EventBus.emit('set:update', result.data);
            }
            const productId = result.product_id ?? id;
            window.fbq?.('track', 'AddToCart', {
                content_ids: [productId],
                content_type: 'product',
                contents: [{ id: productId, quantity: cnt }]
            });
            return true;
        }
        const errorMessage = result.error
            ? Object.values(result.error)[0]
            : 'Ошибка при добавлении товара в корзину';
        console.warn(errorMessage);
        // TODO (toast): Показать ошибку добавления в корзину (errorMessage)
        return false;
    }
    catch (error) {
        console.error('Ошибка при добавлении в корзину:', error);
        // TODO (toast): Показать системную ошибку/сетевой сбой ('Произошла системная ошибка при добавлении товара в корзину')
        return false;
    }
    finally {
        hidePreloader();
    }
}
/**
 * Добавление в корзину по кнопке: тип позиции берётся из data-type (по умолчанию — обычный товар), идентификатор — из data-id
 */
export async function addToCartFromElement(element) {
    const type = (element.dataset.type || 'offer');
    const id = type === 'offer' ? parseInt(element.dataset.id ?? '', 10) : element.dataset.id;
    const button = element instanceof HTMLButtonElement ? element : null;
    if (type === 'offer' && !id) {
        console.warn('Не указан ID товара для добавления в корзину', element);
        return false;
    }
    if (button) {
        button.disabled = true;
    }
    try {
        return await handleAddToCartButtonClick({ id, type });
    }
    finally {
        if (button) {
            button.disabled = false;
        }
    }
}
export function initAddToCartButtons() {
    addGlobalLiveEventListener('click', '.to_basket', function (e) {
        e.preventDefault();
        addToCartFromElement(this);
    });
}
